import { Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { deliveryDateValidator, oneYearAheadISO, tomorrowISO } from '../../../../utils/delivery-date-validator';
import { InfoForm } from '../../form-controls';
import { APIContentLink } from '../../APIVerkooporders';

@Component({
  selector: 'app-new-salesorder-info',
  templateUrl: './new-salesorder-info.component.html',
  styleUrls: ['./new-salesorder-info.component.scss'],
})
export class NewSalesorderInfoComponent {
  static requiredValidator = Validators.required.bind(null);

  @Input() info!: FormGroup<InfoForm>;
  @Input() freshdeskTicketNumbers: number[] = [];
  @Input() contentLinks: APIContentLink[] = [];

  get valid(): boolean {
    return this.info.valid;
  }

  get datePickerMin(): string {
    return tomorrowISO();
  }

  get datePickerMax(): string {
    return oneYearAheadISO();
  }

  static createInfo(fb: FormBuilder, orderReference: string): FormGroup<InfoForm> {
    return fb.group<InfoForm>({
      reason: new FormControl<string>('', {
        nonNullable: true,
        validators: [this.requiredValidator],
      }),
      orderReference: new FormControl<string>(orderReference, {
        nonNullable: true,
        validators: [Validators.maxLength(36)],
      }),
      note: new FormControl<string>('', {
        nonNullable: true,
      }),
      fixedDeliveryDate: new FormControl<string>(tomorrowISO(), {
        nonNullable: true,
        // Empty stays valid on purpose: it means standard carrier delivery (IOM DeliveryDateTypeEnum.STANDARD).
        validators: [deliveryDateValidator(tomorrowISO, oneYearAheadISO, true)],
      }),
    });
  }

  getOrderReference(): string {
    return this.info.controls.orderReference.value;
  }

  getReason(): string {
    return this.info.controls.reason.value;
  }

  getAssessmentNotes(): string {
    return this.info.controls.note.value;
  }

  getFixedDeliveryDate(): string {
    return this.info.controls.fixedDeliveryDate.value;
  }

  getContentLinks(): APIContentLink[] {
    return this.contentLinks.filter(ci => ci.fullContentPath !== null);
  }
}
